import React from 'react'
import { isMobile } from 'react-device-detect'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import ReactRouterPropTypes from 'react-router-prop-types'
import { withRouter } from 'react-router-dom'

import { Modal, ButtonPrimary, ButtonGhost } from 'core/components/ui'
import TitleIcon from '../title-icon'

const ModalDeleteInfo = ({ ...props }) => {
  const {
    setLayoutModalInfo,
    history,
    modalInfos,
    setLayoutVehiclePreview,
    setLayoutTradeInPreview,
    configuration
  } = props

  const { showModal, title, content } = modalInfos

  const removeModal = () => {
    setLayoutModalInfo({
      showModal: false,
      title: null,
      content: null,
      route: null
    })
  }

  const handleOk = () => {
    const { route } = modalInfos
    const { campaign } = configuration
    removeModal()

    setLayoutVehiclePreview(null)
    setLayoutTradeInPreview(null)

    history.push(
      route
        .replace(':tokenCampaign', campaign.uid)
        .replace('/:color1?', '')
        .replace('/:color2?', '')
        .replace('/:isGlobal?', '')
    )
  }

  const handleCancel = () => {
    removeModal()
  }

  return (
    <Modal
      visible={showModal}
      width="auto"
      style={{ maxWidth: isMobile ? '90%' : '60%' }}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <ButtonPrimary className="globaldealer-valid-modal" key="submit" onClick={handleOk}>
          <FormattedMessage id="tradein-modal-delete-vehicle-buttonOk" />
        </ButtonPrimary>,
        <ButtonGhost className="globaldealer-cancel-modal" key="back" onClick={handleCancel}>
          <FormattedMessage id="tradein-modal-delete-vehicle-buttonCancel" />
        </ButtonGhost>
      ]}
    >
      {title && <TitleIcon title={title} small />}
      {content}
    </Modal>
  )
}

ModalDeleteInfo.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  modalInfos: PropTypes.shape().isRequired,
  configuration: PropTypes.shape().isRequired,
  setLayoutModalInfo: PropTypes.func.isRequired,
  setLayoutVehiclePreview: PropTypes.func.isRequired,
  setLayoutTradeInPreview: PropTypes.func.isRequired
}

export default withRouter(ModalDeleteInfo)
